<template>
    <div>
        <!-- Tweet search box -->
        <div style="background: rgb(172,174,171)">
            <div class="container pt-5 pb-5 mb-5">
                <div class="row">
                    <div class="col-12">


                        <h1>Twitter Rumour Verifier</h1>
                        <form method="get" class="form">
                            <div class="form-group">
                                <div class="input-group">

                                    <input list="tweetSearchHistoryList"  type="text" :class="['form-group', 'form-control', {'is-invalid': tweetSearchError}]" name="tweeturl"
                                           placeholder="Enter or paste the twitter URL to verify."
                                           v-model="tweetSearch"/>
                                    <div class="input-group-append">
                                        <input type="submit" class="btn btn-primary" value="Verify!"
                                               @click.prevent="findSourceTweet"/>
                                    </div>
                                </div>
                                <div class="form-error" v-if="tweetSearchError">{{ tweetSearchError }}</div>
                                <datalist id="tweetSearchHistoryList">
                                    <option v-for="tweetId in tweetSearchHistory">{{tweetId}}</option>
                                </datalist>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

        <!-- Show error -->
        <transition name="fade">
            <div class="fixed-top text-center" style="margin-top: 3em; margin-left: auto; margin-right: auto; width: 80%;" v-if="errorMessage">
                <div class="alert alert-warning">{{ errorMessage }}</div>
            </div>
        </transition>


        <transition name="fade">
            <tweet-search-result :tweet-address="tweetSearchConfirm"></tweet-search-result>
        </transition>
    </div>


</template>

<script>
    import TweetSearchResult from "./TweetSearchResult";
    import {mapState, mapActions} from 'vuex'
    const axios = require('axios').default;

    export default {
        name: "App",
        components: {
            TweetSearchResult
        },
        data: function () {
            return {
                tweetSearch: "",
                tweetSearchConfirm: null,
                tweetSearchError: null,
            }
        },
        computed: {
          ...mapState(["tweetSearchHistory", "errorMessage"])
        },
        mounted: function () {

            if (this.$route.params.tweetId) {
                this.tweetSearch = this.$route.params.tweetId;
                this.updateTweetSearch();
            }
        },
        methods: {
            ...mapActions(["displayErrorMessage","clearHistogram"]),
            updateTweetSearch(){

                if (this.$route.params.tweetId) {
                    let tweetIDRegex = /^[0-9]+$/;
                    let matches =this.$route.params.tweetId.trim().match(tweetIDRegex);
                    if (matches) {
                            const tweetId = matches[0];
                            this.tweetSearch = tweetId;
                            this.tweetSearchConfirm = tweetId;
                    }

                }

            },
            findSourceTweet() {

                this.clearHistogram(); // clear any histogram data corresponding to a previous tweet 

                var tweetId = null;

                let tweetAddrRegex = /^https?:\/\/twitter.com\/([\w]+)\/status\/([0-9]+)(\?.+$)?/;
                let matches = this.tweetSearch.trim().match(tweetAddrRegex);

                if (matches && matches.length > 1) {
                    tweetId = matches[2];
                }

                if (!tweetId) {
                    //Check that it's just an ID
                    let tweetIDRegex = /^[0-9]+$/;
                    let matches = this.tweetSearch.trim().match(tweetIDRegex);
                    if (matches) {
                        tweetId = matches[0];
                    }

                }

                if (tweetId) {
                    this.$router.push({path: `/tweet/${tweetId}`}).catch((err) => {
                        console.error(err);
                    });

                    this.tweetSearchError = null;
                }
                else{
                    this.tweetSearchError = `Invalid tweet ID or URL entered`;


                }
            },

        },
        watch: {
            $route(to, from){
                this.updateTweetSearch();
            },
            errorMessage(){
                setTimeout(()=>{
                    this.displayErrorMessage(null);
                }, 4000);
            }
        },
    }
</script>

<style scoped>

</style>
